import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { SearchPersonMarriageNonResidentCrumbs } from 'mutation/constants/registration-marriage-non-resident-crumbs';
import SearchPersonSipo, {
  SearchPersonSipoProps,
} from 'shell/components/shared/search-sipo-person';
import { createSearchParams, generatePath, useNavigate } from 'react-router-dom';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { PersonalDataVM } from 'shell/view-models/personal-data';

interface PersonsPageNonResidentProps extends SearchPersonSipoProps {
  addedTitle?: string;
  goBackUrl?: string;
  onSuccess?: (item: PersonalDataVM) => void;
  onSipoPersonSelected?: (item?: PersonalDataVM) => void;
  redirectUrl?: string;
  editSipoUrl?: string;
  isWithoutBreadcrumb?: boolean;
}

const PersonsPageNonResident = ({
  addedTitle = 'Registrazione Matrimonio Non Residenti',
  goBackUrl,
  onSuccess,
  onSipoPersonSelected,
  isWithoutBreadcrumb,
  redirectUrl = '/mutazioni/persona/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
  editSipoUrl = '/mutazioni/persona/matrimonio/non-residenti/persona-sipo',
  initialValues,
}: PersonsPageNonResidentProps): React.ReactElement => {
  const navigate = useNavigate();

  const handleOnSuccess = useCallback(
    (item) => {
      if (onSuccess) {
        onSuccess(item);
      } else {
        navigate({
          pathname: generatePath(redirectUrl || '', {
            idIntestatario: item?.generality?.municipalityIdentifier || '0',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '0',
          }),
          search: `?${createSearchParams({
            codiceFiscale: item?.fiscalCode || '',
            idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
          })}`,
        });
      }
    },
    [onSuccess, redirectUrl]
  );

  const handleOnSipoSelected = useCallback(
    (item) => {
      if (onSipoPersonSelected) {
        onSipoPersonSelected(item);
      } else {
        navigate(
          {
            pathname: generatePath(editSipoUrl || ''),
            search: `?${createSearchParams({
              idIntestatario:
                item?.idSchedaSoggetto || item?.generality?.municipalityIdentifier || '',
              idSchedaSoggettoANPR: item?.generality?.anprIdentifier || '',
              codiceFiscale: item?.fiscalCode || '',
            })}`,
          },
          {
            state: item,
          }
        );
      }
    },
    [onSipoPersonSelected, editSipoUrl]
  );

  return (
    <Fragment>
      {isWithoutBreadcrumb ? undefined : (
        <Breadcrumbs items={SearchPersonMarriageNonResidentCrumbs} />
      )}
      <SearchPersonSipo
        url={`${__PERSON_API_URL__}/non-residenti/ricerca-intestatario-matrimonio`}
        addedTitle={addedTitle}
        goBackUrl={goBackUrl}
        onSuccess={handleOnSuccess}
        onSipoPersonSelected={handleOnSipoSelected}
        initialValues={initialValues}
      />
    </Fragment>
  );
};

PersonsPageNonResident.displayName = 'Persons Non resident page component';

export default PersonsPageNonResident;
